// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthLayout_wrapper__OT2Pt"};